import React from 'react';
import { Route, Switch } from "react-router";
import PickerIframeWrapper from './components/PickerIframeWrapper';
import Picker from './components/Picker';

function App() {
  return (<Switch>
    <Route exact path="/picker">
      <Picker />
    </Route>
    <Route>
      <PickerIframeWrapper />
    </Route>
  </Switch>);
}

export default App;
